import { IsArray, IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';

export enum MessageStatus {
  SENDING = 'sending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  SEEN = 'seen',
  FAILED = 'failed'
}

export class MessageStatusOverviewDto {
  @IsString()
  messageId: string;

  @IsNumber()
  deliveredCount: number;

  @IsNumber()
  seenCount: number;

  @IsArray()
  @IsString({ each: true })
  deliveredUsers: string[];

  @IsArray()
  @IsString({ each: true })
  seenUsers: string[];

  constructor(data: Partial<MessageStatusOverviewDto> = {}) {
    this.messageId = data.messageId || '';
    this.deliveredCount = data.deliveredCount || 0;
    this.seenCount = data.seenCount || 0;
    this.deliveredUsers = data.deliveredUsers || [];
    this.seenUsers = data.seenUsers || [];
  }
}

export class MessageStatusUserDto {
  @IsString()
  userId: string;

  @IsString()
  displayName: string;

  @IsOptional()
  @IsString()
  avatarUrl?: string;

  @IsString()
  timestamp: string; // ISO string

  constructor(data: Partial<MessageStatusUserDto> = {}) {
    this.userId = data.userId || '';
    this.displayName = data.displayName || '';
    this.avatarUrl = data.avatarUrl;
    this.timestamp = data.timestamp || '';
  }
}

export class MessageStatusUsersResponseDto {
  @IsString()
  messageId: string;

  @IsString()
  status: 'delivered' | 'seen';

  @IsArray()
  users: MessageStatusUserDto[];

  @IsNumber()
  totalCount: number;

  @IsOptional()
  @IsString()
  pagingState: string | null;

  @IsBoolean()
  hasMore: boolean;

  constructor(data: Partial<MessageStatusUsersResponseDto> = {}) {
    this.messageId = data.messageId || '';
    this.status = data.status || 'delivered';
    this.users = data.users || [];
    this.totalCount = data.totalCount || 0;
    this.pagingState = data.pagingState || null;
    this.hasMore = data.hasMore || false;
  }
}

export class AckItem {
  @IsString()
  conversationId: string;

  @IsString()
  messageId: string;

  constructor(conversationId: string, messageId: string) {
    this.conversationId = conversationId;
    this.messageId = messageId;
  }
}

export class AckMultipleDeliveredDto {
  @IsArray()
  acks: AckItem[];

  @IsOptional()
  @IsString()
  clientType?: string;

  @IsOptional()
  @IsString()
  deviceId?: string;

  constructor(acks: AckItem[], clientType?: string, deviceId?: string) {
    this.acks = acks;
    this.clientType = clientType;
    this.deviceId = deviceId;
  }
}
